import React, { useRef, useState, useCallback, useMemo, useEffect } from "react";
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import { SearchInput, Table } from "Components/uiControls";
import { Button } from "Components";
import { Grid, Typography, Tooltip } from "@mui/material";
import { openOverViewUnit } from "Redux/actions";

import './style.scss';
import { useSelector, useDispatch } from "react-redux";
import { useRealtimeUnits } from 'Core/hooks';
import { IconButton } from "@gpstrackit/gtc-react-controls";


const getColumns = (messages, label, modelOverView) => [
  {
    key: 'label',
    show: true,
    sort: true,
    title: `${messages['dashboardPanel_vehicles']}`,
    sortValue: (item) => item?.label,
    export: false,
    render: (item) => (
      <Grid item xs zeroMinWidth style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '95%' }}>

        <IconButton
          style={{ color: 'black' }}
          icon="gps_fixed"
          tooltip={messages["unitOverViewPanel"]}
          onClick={() => {
            modelOverView(item)
          }} />
        <Tooltip title={item?.label} placement="bottom">
          <Typography noWrap >{item?.label}</Typography>
        </Tooltip>
      </Grid>
    )
  }
];


export const ModalSearchUnits = ({ messages, modalInformation, setModalInformation }) => {
  const tableRef = useRef();
  const [searchText, setSearchText] = useState('');
  const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });
  const dispatch = useDispatch();

  const handleCancel = useCallback(() => {
    tableRef.current.setPage(1);
    tableRef.current.setSelectedItems([]);
    setModalInformation((prev) => ({
      ...prev,
      open: false
    }));
  }, [setModalInformation]);


  const modelOverView = (unit) => {
    const item = units.find((item) => item.id == unit.id)
    dispatch(
      openOverViewUnit({
        data: { unit: item },
        open: true,
      }))
  }


  const columns = useMemo(() => getColumns(messages, modalInformation.label, modelOverView), [messages, modalInformation.label]);

  const onChangeSearchText = useCallback((newSearchText) => {
    setSearchText(newSearchText);
    tableRef.current.setPage(1);
    tableRef.current.setSelectedItems([]);
  }, []);

  return (
    <Modal
      title={modalInformation.label || ''}
      open={modalInformation.open}
      handleClose={handleCancel}
      size="extra-small"
      position="right"
      useCloseButtonTop
      hiddenCloseButton
      className="modalUnits"
    >
      <ModalBody className="modal-body">
        <div className="modal-search-report-list-filter">
          <SearchInput
            placeholder={messages['search']}
            searchText={searchText}
            onSearchText={onChangeSearchText}
          />
        </div>
        <div className="modal-div-report-list-filter">
          <Table
            ref={tableRef}
            data={modalInformation.data}
            order={'asc'}
            loading={false}
            keyColumn="id"
            topheight={300}
            columns={columns}
            searchText={searchText}
            valuesPerPage={[]}
            fixHeader
            className="modal-table-report-list-filter"
            hideDragable
            disableItemSelection
            hidePerPage
            hideTotal
            hideAllInPagination
            selectAllRows={modalInformation.data.length}
            messageNoData={messages['reportsMainST_withoutSchedules']}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className='btn-blue' onClick={handleCancel}>
          {messages['close']}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
